// Centralized configuration for the application
export const BASE_API_URL = 'https://api.veilstream.com'

// Environment-specific overrides
export const API_URL = import.meta.env.VITE_BACKEND_URL || BASE_API_URL

// GitHub OAuth configuration
export const GITHUB_CALLBACK_URL = import.meta.env.VITE_GITHUB_CALLBACK_URL || `${BASE_API_URL}/api/auth/github/callback`

// GitHub App configuration
// Defaults to production app, but can be overridden for development
// Auto-detect dev environment based on API URL
const isDevEnvironment = API_URL.includes('veilstreamdev.com') || API_URL.includes('localhost')
export const GITHUB_APP_NAME = import.meta.env.VITE_GITHUB_APP_NAME || (isDevEnvironment ? 'veilstream-development-bot' : 'veilstream')
export const GITHUB_APP_URL = `https://github.com/apps/${GITHUB_APP_NAME}`
export const GITHUB_APP_INSTALL_URL = `https://github.com/apps/${GITHUB_APP_NAME}/installations/new`

// WebSocket configuration
export const WS_URL = API_URL.replace('http', 'ws').replace('https', 'wss')
